(function() {
    'use strict';
    
    let stickyBar = null;
    let atcButton = null;
    let observers = [];
    
    // Main initialization
    function init() {
        // Find elements
        stickyBar = document.querySelector('.product-sticky');
        atcButton = document.querySelector('.add-to-cart');
        
        if (!stickyBar) {
            setTimeout(init, 500);
            return;
        }
        
        // Remove hidden class
        stickyBar.classList.remove('product-sticky--hidden');
        
        // Add CSS fixes without breaking layout
        addCSSFixes();
        
        // Set up Intersection Observers for hide/show behavior
        setupObservers();
        
        // Fix click handlers
        fixClickHandlers();
        
        // Prevent theme from breaking our fix
        protectFromTheme();
    }
    
    // Add CSS that only fixes visibility, not layout
    function addCSSFixes() {
        const styleId = 'sticky-atc-fix';
        if (document.getElementById(styleId)) return;
        
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            /* Preserve original styling but fix visibility */
            .product-sticky {
                opacity: 1 !important;
                visibility: visible !important;
                pointer-events: auto !important;
                display: block !important;
                transition: opacity 0.3s ease, visibility 0.3s ease !important;
            }
            
            /* Our custom hide state */
            .product-sticky.hidden-by-sticky-fix {
                opacity: 0 !important;
                visibility: hidden !important;
                pointer-events: none !important;
            }
            
            /* Ensure proper stacking without affecting original positioning */
            .product-sticky {
                z-index: 99999 !important;
            }
        `;
        document.head.appendChild(style);
    }
    
    // Set up Intersection Observers
    function setupObservers() {
        // Clear any existing observers
        observers.forEach(obs => obs.disconnect());
        observers = [];
        
        // Observer for main ATC button
        if (atcButton) {
            const atcObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // ATC is visible - hide sticky bar
                        stickyBar.classList.add('hidden-by-sticky-fix');
                    } else {
                        // ATC not visible - show sticky bar
                        stickyBar.classList.remove('hidden-by-sticky-fix');
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px -100px 0px'
            });
            
            atcObserver.observe(atcButton);
            observers.push(atcObserver);
        }
        
        // Observer for footer
        const footer = document.querySelector('.site-footer');
        if (footer) {
            const footerObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        stickyBar.classList.add('hidden-by-sticky-fix');
                    }
                });
            }, { threshold: 0.1 });
            
            footerObserver.observe(footer);
            observers.push(footerObserver);
        }
    }
    
    // Fix click handlers
    function fixClickHandlers() {
        const submitButton = stickyBar.querySelector('[data-ref="submitButton"]');
        const editButton = stickyBar.querySelector('[data-ref="editButton"]');
        
        // Add to Cart button
        if (submitButton && atcButton) {
            // Remove any existing listeners by replacing the button
            const newSubmit = submitButton.cloneNode(true);
            submitButton.parentNode.replaceChild(newSubmit, submitButton);
            
            newSubmit.addEventListener('click', (e) => {
                e.preventDefault();
                
                // Visual feedback
                const originalText = newSubmit.textContent;
                newSubmit.textContent = 'Adding...';
                newSubmit.disabled = true;
                
                if (!atcButton.disabled) {
                    atcButton.click();
                    
                    // Reset button after delay
                    setTimeout(() => {
                        newSubmit.textContent = originalText;
                        newSubmit.disabled = false;
                    }, 2000);
                }
            });
        }
        
        // Edit button
        if (editButton) {
            const newEdit = editButton.cloneNode(true);
            editButton.parentNode.replaceChild(newEdit, editButton);
            
            newEdit.addEventListener('click', (e) => {
                e.preventDefault();
                const productMain = document.querySelector('.product-grid__content');
                if (productMain) {
                    productMain.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'start' 
                    });
                }
            });
        }
    }
    
    // Protect from theme interference
    function protectFromTheme() {
        // Mutation observer to prevent theme from adding hidden class back
        const mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    // If theme adds product-sticky--hidden, remove it
                    if (stickyBar.classList.contains('product-sticky--hidden')) {
                        stickyBar.classList.remove('product-sticky--hidden');
                    }
                    
                    // If theme removes our custom class, add it back if needed
                    const atcVisible = atcButton ? isElementInViewport(atcButton) : false;
                    
                    if (atcVisible && !stickyBar.classList.contains('hidden-by-sticky-fix')) {
                        stickyBar.classList.add('hidden-by-sticky-fix');
                    } else if (!atcVisible && stickyBar.classList.contains('hidden-by-sticky-fix')) {
                        stickyBar.classList.remove('hidden-by-sticky-fix');
                    }
                }
            });
        });
        
        mutationObserver.observe(stickyBar, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        observers.push(mutationObserver);
    }
    
    // Helper function to check if element is in viewport
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    // Handle page changes
    function handlePageChanges() {
        // Reinitialize on Shopify section loads
        document.addEventListener('shopify:section:load', () => {
            setTimeout(init, 100);
        });
        
        // Reinitialize on AJAX page changes
        document.addEventListener('ajaxComplete', () => {
            setTimeout(init, 100);
        });
    }
    
    // Start everything
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(init, 1000);
            handlePageChanges();
        });
    } else {
        setTimeout(init, 1000);
        handlePageChanges();
    }
})();